module.exports = __webpack_public_path__ + "img/no.d27dd8f0.svg";